import React, { useEffect, useState, useRef } from "react";
import { collection, getDocs, orderBy, query, doc, getDoc } from "firebase/firestore";
import { db } from "../../services/firebase";
import LoadingSpinner from "../LoadingSpinner";
import { ReactComponent as FileIcon } from '../../assets/icons/FileIcon.svg'; 
import { ReactComponent as SearchIcon } from '../../assets/icons/SearchIcon.svg';
import { ReactComponent as EditIcon } from '../../assets/icons/EditIcon.svg';
import ClientesForm from "./ClientesForm";
import EmptyState from "../EmptyState";
import { useNavigate, useLocation } from "react-router-dom";
const cleanId = (id) => (id || '').toString().replace(/[\.\-\s]/g, '');
const getClienteIdsLimpios = (cliente) => {
const ids = [cliente.id];
if (cliente.numeroDeDocumento) ids.push(cleanId(cliente.numeroDeDocumento));
if (cliente.cuit) ids.push(cleanId(cliente.cuit));
return ids;
}
const Tooltip = ({ cliente, children, type = "nombre", delay = 250, offsetX = 0, offsetY = 0 }) => {
const [isHovered, setIsHovered] = useState(false);
const [coords, setCoords] = useState({ top: 0, left: 0 });
const ref = React.useRef();
const timeoutRef = React.useRef();
const formatDateTime = (fecha) => {
if (!fecha) return "-";
const date = fecha.toDate ? fecha.toDate() : new Date(fecha);
const day = String(date.getDate()).padStart(2, "0");
const month = String(date.getMonth() + 1).padStart(2, "0");
const year = date.getFullYear();
const hours = String(date.getHours()).padStart(2, "0");
const minutes = String(date.getMinutes()).padStart(2, "0");
return `el ${day}/${month}/${year} a las ${hours}:${minutes}`;
};
const handleMouseEnter = () => {
const rect = ref.current.getBoundingClientRect();
setCoords({
top: rect.bottom + window.scrollY + 5 + offsetY,
left: rect.left + rect.width / 2 + window.scrollX + offsetX,
});
timeoutRef.current = setTimeout(() => setIsHovered(true), delay);
};
const handleMouseLeave = () => {
clearTimeout(timeoutRef.current);
setIsHovered(false);
};
const renderContent = () => {
switch (type) {
case "nombre":
return (
<>
<div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
<div>
<strong style={{color: '#999', fontSize:'13px', fontFamily:'Effra', fontWeight:'normal'}}>
{cliente.personeria === "persona fisica"
? `${(cliente.apellido || '').toUpperCase()}, ${cliente.nombre || ""}`
: cliente.razonSocial || ""}
</strong></div>
<div style={{color: '#2c2c2c', fontSize:'13px', fontFamily:'Effra'}}>
Creado por:
<p style={{color:'#999', margin:'0', fontSize:'13px'}}>{cliente.creador || "-"}</p>
<p style={{color:'#999', margin:'0', fontSize:'13px'}}>{formatDateTime(cliente.fechaCreacion)}</p>
{cliente.modificador && cliente.ultimaActualizacion && (
<>
<hr style={{borderColor:'#ebeef2'}}></hr>
Modificado por:
<p style={{color:'#999', margin:'0', fontSize:'13px'}}>{cliente.modificador || "-"}</p>
<p style={{color:'#999', margin:'0', fontSize:'13px'}}>{formatDateTime(cliente.ultimaActualizacion)}</p>
</>
)}</div>
</div>
</>
);
case "domicilio":
return (
<>
<div style={{ display: 'flex', flexDirection: 'column', gap: '5px',textAlign:'left' }}>
<div>
<strong style={{color: '#2c2c2c', fontSize:'13px', fontFamily:'Effra',textAlign:'left', fontWeight:'normal'}}>
{cliente.calle}  {cliente.altura}, {cliente.piso}{cliente.unidad}
</strong></div>
<div style={{color: '#2c2c2c', fontSize:'13px', fontFamily:'Effra', textAlign:'left'}}>
<p style={{color:'#999', margin:'0', fontSize:'13px'}}> {cliente.codigoPostal}</p>
<p style={{color:'#999', margin:'0', fontSize:'13px'}}> {cliente.ciudad}, {cliente.pais}</p>
</div>
</div>
</>
);
case "correo":
return (
<>
<div style={{ display: 'flex', flexDirection: 'column', gap: '5px',textAlign:'left' }}>
<div>
<strong style={{color: '#2c2c2c', fontSize:'13px', fontFamily:'Effra',textAlign:'left', fontWeight:'normal'}}>
{cliente.correoElectronico}
</strong></div>
</div>
</>
);
default:
return null;
}
};
return (
<>
<div
ref={ref}
style={{ display: "inline-block" }}
onMouseEnter={handleMouseEnter}
onMouseLeave={handleMouseLeave}
>
{children}
</div>
{isHovered && (
<div
style={{
position: "absolute",
top: coords.top,
backgroundColor: "#f9fafd",
padding: "8px 12px",
borderRadius: "4px",
whiteSpace: "normal",
zIndex: 1000,
fontSize: "14px",
minWidth: "200px",
pointerEvents: "none",
boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
}}
>
{renderContent()}
</div>
)}
</>
);
};
const Clientes = () => {
const [clientes, setClientes] = useState([]);
const [recientes, setRecientes] = useState([]);
const [loading, setLoading] = useState(true);
const [activeTab, setActiveTab] = useState('lista');
const [estadoClientes, setEstadoClientes] = useState(null);
const [searchTerm, setSearchTerm] = useState('');
const [filteredClients, setFilteredClients] = useState([]);
const [selectedClient, setSelectedClient] = useState(null);
const [activeLetter, setActiveLetter] = useState('');
const [sortField, setSortField] = useState('');
const [sortOrder, setSortOrder] = useState('desc');
const containerRef = useRef(null);
const [openDropdown, setOpenDropdown] = useState(false);
const navigate = useNavigate();
const location = useLocation();
const [clienteParaEditar, setClienteParaEditar] = useState(null);
// Abrir "editar" en un modal no dejaba rastro en el historial del
// navegador: la flecha "atrás" saltaba directo a la pantalla anterior a
// Clientes en vez de cerrar el modal. Empujando 'editandoId' al abrir, y
// mirándolo acá, la flecha "atrás" cierra el modal y te deja en Clientes.
useEffect(() => {
const id = location.state?.editandoId;
if (!id) {
setClienteParaEditar(null);
return;
}
setClienteParaEditar(prev => (prev?.id === id ? prev : clientes.find(c => c.id === id) || prev));
}, [location.state, clientes]);
useEffect(() => {
const handleClickOutside = (event) => {
if (containerRef.current && !containerRef.current.contains(event.target)) {
setOpenDropdown(false);
}
};
document.addEventListener("mousedown", handleClickOutside);
return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);
const fetchData = async () => {
  try {
    const clientesQuery = query(collection(db, "clientes"), orderBy("fechaCreacion", "desc"));
    const clientesSnap = await getDocs(clientesQuery);
    // Cuentas de staff usadas para probar el sitio publico como si fueran
    // clientes (Martin Gallo, Tomas Sitta) -- no son clientes reales, no
    // deben aparecer en esta lista ni en "recientes". Sacar cuando ya no
    // hagan falta para pruebas.
    const UIDS_CUENTAS_DE_PRUEBA = ['31464078', '42876938', '34853820', '36398917'];
    const clientesData = clientesSnap.docs
      .filter((doc) => !UIDS_CUENTAS_DE_PRUEBA.includes(doc.id))
      .map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
    setClientes(clientesData);
    setRecientes(clientesData.slice(0, 4));
    const estadoClientesRef = doc(db, "lista", "estado_clientes"); 
    const estadoClientesSnap = await getDoc(estadoClientesRef); 
    if (estadoClientesSnap.exists()) {
      setEstadoClientes(estadoClientesSnap.data());
    } else {
      console.log("El documento estado_clientes no existe.");
      setEstadoClientes({ activa: [], espera: [] }); 
    }
  } catch (error) {
    console.error("Error al traer datos:", error);
  } finally {
    setLoading(false);
  }
};
useEffect(() => {
fetchData();
}, []);
useEffect(() => {
if (searchTerm.length > 0 && !selectedClient) {
const lowerSearchTerm = searchTerm.toLowerCase().replace(/[\.-]/g, '');
const results = clientes.filter(cliente => {
const nombreCompleto = `${cliente.nombre || ''} ${cliente.apellido || ''}`.toLowerCase();
const numeroDeDocumento = cleanId(cliente.numeroDeDocumento);
const razonSocial = (cliente.razonSocial || '').toLowerCase();
const cuit = cleanId(cliente.cuit);
return (nombreCompleto.includes(lowerSearchTerm) ||
numeroDeDocumento.includes(lowerSearchTerm) ||
razonSocial.includes(lowerSearchTerm) ||
cuit.includes(lowerSearchTerm));
});
setFilteredClients(results);
} else {
setFilteredClients([]);
}
}, [searchTerm, clientes, selectedClient]);
if (loading) return <LoadingSpinner />;
const handleSort = (field) => {
if (activeTab === 'lista') return;
if (sortField === field) {
setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
} else {
setSortField(field);
setSortOrder('asc');
}
};
const formatearFecha = (fecha) => {
if (!fecha) return "-";
const date = fecha.toDate ? fecha.toDate() : new Date(fecha);
return date.toLocaleDateString("es-AR");
};
const formatearDomicilio = (cliente) => {
const { calle, altura, piso, unidad, codigoPostal, ciudad, pais } = cliente;
let direccion = '';
if (calle) direccion += `${calle}`;
if (altura) direccion += ` ${altura}`;
if (piso && unidad) {
direccion += `, ${piso}° ${unidad}`;
} else if (piso === 'PB') {
direccion += `, ${piso}`;
} else if (piso) {
direccion += `, ${piso}°`;
} else if (unidad) {
direccion += `, Dpto. ${unidad}`;
}
if (ciudad) direccion += `, ${ciudad}`;
if (codigoPostal) direccion += ` (${codigoPostal})`;
if (pais) direccion += `, ${pais}`;
return direccion || "-";
};
const handleSelectClient = (cliente) => {
setSelectedClient(cliente); 
setOpenDropdown(false);
setActiveTab(cliente.personeria); 
setSearchTerm(cliente.personeria === 'persona fisica' ? `${cliente.nombre || ''} ${cliente.apellido || ''}` : cliente.razonSocial || ''); 
setFilteredClients([]);
setActiveLetter('');
navigate(`/clientes/${cliente.id}`);
};
const handleLetterClick = (letter) => {
setActiveLetter(activeLetter === letter ? '' : letter);
setSearchTerm('');
setSelectedClient(null);
};
const resetSearch = () => {
setSearchTerm('');
setFilteredClients([]);
setSelectedClient(null);
setActiveLetter('');
setOpenDropdown(false)
};
let columnas = [];
let clientesParaMostrar = [];
// Variable para guardar el Set que usaremos en el renderizado del color
let activaSetParaColor = null; 

if (selectedClient) {
    clientesParaMostrar = [selectedClient];
} else if (activeTab === 'lista' && estadoClientes) {

    // 1. Preprocesar las listas de IDs: Limpiar IDs y guardar el Set.
    const activaLimpiaSet = new Set(estadoClientes.activa.map(cleanId));
activaSetParaColor = activaLimpiaSet; // 👈 LO GUARDAMOS AQUÍ

    const ordenIDsLimpio = [...estadoClientes.activa.map(cleanId), ...estadoClientes.espera.map(cleanId)];
    
    const clientesMap = clientes.reduce((map, cliente) => {
        const ids = getClienteIdsLimpios(cliente);
        ids.forEach(id => {
            if (id) map[id] = cliente;
        });
        return map;
    }, {});
    
    let clientesOrdenados = [];
    const clientesYaAgregados = new Set();
    
    for (const idLimpio of ordenIDsLimpio) {
        const cliente = clientesMap[idLimpio];
        if (cliente && !clientesYaAgregados.has(cliente.id)) {
            clientesOrdenados.push(cliente);
            clientesYaAgregados.add(cliente.id);
        }
    }
if (activeLetter) {
        clientesParaMostrar = clientesOrdenados.filter(c => {
            const primerLetra = c.personeria === 'persona fisica' ? (c.apellido || '')[0] : (c.razonSocial || '')[0];
            return primerLetra?.toUpperCase() === activeLetter;
        });
    } else {
        clientesParaMostrar = clientesOrdenados;
    }
    columnas = [
        { id: 'nombreCompleto', header: 'Nombre / Razón Social', render: (cliente) => cliente.personeria === 'persona fisica' ? `${(cliente.apellido || '-').toUpperCase()}, ${cliente.nombre || '-'}` : cliente.razonSocial || '-' },
        { id: 'documento', header: 'Documento / CUIT', render: (cliente) => cliente.personeria === 'persona fisica' ? cliente.numeroDeDocumento || '-' : cliente.cuit || '-' },
        { id: 'fechaCreacion', header: 'Fecha de alta', render: (cliente) => formatearFecha(cliente.fechaCreacion) },
        { id: 'domicilio', header: 'Domicilio', render: (cliente) => formatearDomicilio(cliente) },
        { id: 'telefono', header: 'Teléfono', render: (cliente) => cliente.telefono || '-' },
        { id: 'correoElectronico', header: 'Correo Electrónico', render: (cliente) => cliente.correoElectronico || '-' }
    ];
    clientesParaMostrar.activaLimpiaSet = activaLimpiaSet;
} else {
const clientesFiltradosPorTab = activeTab === 'todos' ? clientes : clientes.filter(c => c.personeria === activeTab);
if (activeLetter) {
clientesParaMostrar = clientesFiltradosPorTab.filter(c => {
const primerLetra = c.personeria === 'persona fisica' ? (c.apellido || '')[0] : (c.razonSocial || '')[0];
return primerLetra?.toUpperCase() === activeLetter;
});
} else {
clientesParaMostrar = clientesFiltradosPorTab;
}
clientesParaMostrar.sort((a, b) => {
let aValue;
let bValue;
switch (sortField) {
case 'nombreCompleto':
aValue = (a.apellido || '').toUpperCase();
bValue = (b.apellido || '').toUpperCase();
break;
case 'numeroDeDocumento':
case 'cuit':
aValue = parseInt(cleanId(a[sortField]), 10) || 0;
bValue = parseInt(cleanId(b[sortField]), 10) || 0;
break;
case 'domicilio':
aValue = (a.calle || '').toLowerCase();
bValue = (b.calle || '').toLowerCase();
break;
case 'tipoPersoneria':
aValue = (a.personeria || '').toLowerCase();
bValue = (b.personeria || '').toLowerCase();
break;
default:
aValue = a[sortField];
bValue = b[sortField];
}
if (aValue < bValue) return sortOrder === 'asc' ? -1 : 1;
if (aValue > bValue) return sortOrder === 'asc' ? 1 : -1;
return 0;
});
const tipoCliente = selectedClient ? selectedClient.personeria : activeTab;
if (tipoCliente === 'persona juridica') {
columnas = [
{ id: 'razonSocial', header: 'Razón social', render: (cliente) => cliente.razonSocial || '-' },
{ id: 'cuit', header: 'CUIT', render: (cliente) => cliente.cuit || '-' },
{ id: 'fechaCreacion', header: 'Fecha de alta', render: (cliente) => formatearFecha(cliente.fechaCreacion) },
{ id: 'domicilio', header: 'Domicilio', render: (cliente) => formatearDomicilio(cliente) },
{ id: 'telefono', header: 'Teléfono', render: (cliente) => cliente.telefono || '-' },
{ id: 'correoElectronico', header: 'Correo electrónico', render: (cliente) => cliente.correoElectronico || '-' }
];
} else if (tipoCliente === 'persona fisica') {
columnas = [
{ id: 'nombreCompleto', header: 'Apellido y nombre', render: (cliente) => `${(cliente.apellido || '-').toUpperCase()}, ${cliente.nombre || '-'}` },
{
id: 'fechaDeNacimiento',
header: 'Fecha de nacimiento',
render: (cliente) => formatearFecha(cliente.fechaDeNacimiento)
},
{
id: 'numeroDeDocumento',
header: 'Documento',
render: (cliente) => {
const tipoAbreviado = {
'DNI': 'DNI',
'Pasaporte': 'P',
'Libreta Cívica': 'LC'
}[cliente.tipo] || '';
return `${tipoAbreviado} ${cliente.numeroDeDocumento || '-'}`;
}
},
{ id: 'domicilio', header: 'Domicilio', render: (cliente) => formatearDomicilio(cliente) },
{ id: 'telefono', header: 'Teléfono', render: (cliente) => cliente.telefono || '-' },
{ id: 'correoElectronico', header: 'Correo electrónico', render: (cliente) => cliente.correoElectronico || '-' }
];
}
}
const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
return (
<div className="Trazabilidad" >
{!clienteParaEditar && (
<header className="trazabilidad-header">
<div className="header-content">
<h1>Clientes</h1>
</div>
</header>)}
{!clienteParaEditar && (clientes.length === 0 ? (
<EmptyState label="clientes" />
) : (
<div className="trazabilidad-content">
<div className="section">
<h2>Recientes</h2>
{recientes.length === 0 ? (
<p></p>
) : (
<div className="recent-grid">
{recientes.map((cliente) => (
<div
key={cliente.id}
className="document-card recent-card"
onClick={() => handleSelectClient(cliente)}
style={{
flexDirection: "column",
textAlign: "left",
alignItems: "start",
justifyContent: "start",
gap: "2px",
cursor: "pointer",
}}
>
<span className="doc-id" style={{ margin: 0 }}>
{cliente.personeria === 'persona fisica'
? `${(cliente.apellido || '').toUpperCase()}, ${cliente.nombre || ''}`
: cliente.razonSocial || ''}
</span>
<p className="card-date" style={{ margin: 0 }}>
{cliente.creador || 'Finca Los Astros'}
</p>
</div>
))}
</div>
)}
</div>
<div className="clientes-search-bar-container" ref={containerRef}>
<div className={`clientes-search-input-wrapper ${openDropdown ? 'active' : ''}`}>
<div className="clientes-search-icon-wrapper">
<SearchIcon className="clientes-search-icon" />
</div>
<input
type="text"
placeholder="Buscar un cliente"
value={searchTerm}
onChange={(e) => {
setSearchTerm(e.target.value);
setSelectedClient(null);
setActiveLetter('');
setOpenDropdown(true);
}}
onFocus={() => setOpenDropdown(true)}
className="clientes-search-input"
/>
{(searchTerm.length > 0 || selectedClient || activeLetter) && (
<button className="clientes-search-reset-button" onClick={resetSearch}>
×
</button>
)}
</div>
{openDropdown && filteredClients.length > 0 && (
<div className="clientes-search-dropdown-options">
{filteredClients.length > 0 ? (
filteredClients.map((cliente) => (
<div
key={cliente.id}
className="clientes-search-dropdown-option"
onClick={() => handleSelectClient(cliente)}
>
{cliente.personeria === 'persona fisica'
? `${cliente.nombre || ''} ${cliente.apellido || ''}`
: cliente.razonSocial || ''}
</div>
))
) : (
<div className="clientes-search-dropdown-option">
</div>
)}
</div>
)}
</div>
<div className="alphabet-filter">
{alphabet.map(letter => (
<button
key={letter}
className={`letter-button ${activeLetter === letter ? 'active' : ''}`}
onClick={() => handleLetterClick(letter)}
>
{letter}
</button>
))}
</div>
<ul className="clientes-tabs">
<li className={activeTab === "lista" ? "active" : ""}> 
<a
href="#"
onClick={(e) => {
e.preventDefault();
setActiveTab("lista");
setSelectedClient(null);
setSearchTerm("");
setActiveLetter("");
}}
>Lista
</a>
</li>
<li className={activeTab === "persona fisica" ? "active" : ""}>
<a
href="#"
onClick={(e) => {
e.preventDefault();
setActiveTab("persona fisica");
setSelectedClient(null);
setSearchTerm("");
setActiveLetter("");
}}
>Físicas
</a>
</li>
<li className={activeTab === "persona juridica" ? "active" : ""}>
<a
href="#"
onClick={(e) => {
e.preventDefault();
setActiveTab("persona juridica");
setSelectedClient(null);
setSearchTerm("");
setActiveLetter("");
}}
>Jurídicas
</a>
</li>

</ul>
<div className="section">
{clientesParaMostrar.length === 0 ? (
<p></p>
) : (
<div className="table-container">
<table className="table-full" style={{ textAlign: 'center', }}>
<thead>
<tr>
{/* Columna del lapicito: sin encabezado, del ancho del ícono. */}
<th className="col-editar"></th>
{columnas.map(col => (
<th
key={col.id}
style={{ fontFamily: 'Effra', fontWeight: '600', cursor: activeTab !== 'lista' ? 'pointer' : 'default', margin: '0 auto', textAlign: 'center',fontSize:'14px' }}
onClick={() => handleSort(col.id)}
>
<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px', textAlign: 'center', margin: '0 auto' }}>
{col.header}
{sortField === col.id && activeTab !== 'lista' && (
<span className={`arrow ${sortOrder}`}></span>
)}
</div>
</th>
))}
</tr>
</thead>
<tbody>
{clientesParaMostrar.map((cliente) => {
let isActivo = false;
// Comprobación correcta usando la variable local activaSetParaColor
if (activeTab === 'lista' && activaSetParaColor) { 
const clienteIdsLimpios = getClienteIdsLimpios(cliente);
// Verificamos si alguno de los IDs limpios del cliente existe en el Set
isActivo = clienteIdsLimpios.some(id => activaSetParaColor.has(id)); 
}

const nombreColor = isActivo ? '#e65c5c' : 'black';
return (
<tr className="table-row" key={cliente.id} onClick={() => handleSelectClient(cliente)}>
<td className="col-editar">
<button
onClick={(e) => {
e.stopPropagation();
setClienteParaEditar(cliente);
navigate(location.pathname, { state: { ...location.state, editandoId: cliente.id } });
}}
title="Editar cliente"
style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'inline-flex', alignItems: 'center' }}
>
<EditIcon style={{ width: '16px', height: '16px' }} />
</button>
</td>
{columnas.map((col, idx) => {
let content;
if (idx === 0) {
content = (
<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
<span
style={{
display: 'inline-block',
maxWidth: '150px',
whiteSpace: 'nowrap',
overflow: 'hidden',
textOverflow: 'ellipsis',
verticalAlign: 'middle',
color: nombreColor, 
}}
>
{col.render(cliente)}
</span>
</div>
);
} else {
content = (
<span
style={{
display: 'inline-block',
maxWidth: '165px',
whiteSpace: 'nowrap',
overflow: 'hidden',
textOverflow: 'ellipsis',
verticalAlign: 'middle',
}}
>
{col.render(cliente)}
</span>
);
}
const tooltipType = col.id === "domicilio" ? "domicilio" : col.id === "correoElectronico" ? "correo" : "nombre";
return (
<td
key={col.id}
style={{
maxWidth: "10px",
textAlign: col.id === "razonSocial" || col.id === "nombreCompleto" ? "left" : "center",
whiteSpace: "nowrap",
overflow: "hidden",
textOverflow: "ellipsis",
verticalAlign: "middle",
}}
>
{(col.id === "nombreCompleto" || col.id === "razonSocial" || col.id === "domicilio" || col.id === "correoElectronico") ? (
<Tooltip cliente={cliente} type={tooltipType}>
{content}
</Tooltip>
) : (
content
)}
</td>
);
})}
</tr>
);
})}
</tbody>
</table>
</div>
)}
</div>
</div>
))}
{clienteParaEditar && (
<ClientesForm
clienteParaEditar={clienteParaEditar}
onClose={() => navigate(-1)}
onSuccess={() => {
navigate(-1);
fetchData();
}}
/>
)}
</div>
);
};
export default Clientes;